import React, {useState} from 'react';
import {Button, Form, Input} from 'antd';
import {MailOutlined, LockOutlined} from '@ant-design/icons';
import {useAppDispatch, useAppState} from '@nutastic/nutastic-react-app';
import {forgotPasswordRequest, logIntoApplication} from '../../../state/actions.mjs';
import classnames from "classnames";

const componentClass = 'loginForm';

export const LoginForm = ({ emailValue, onLoginComplete, onCancel, hideEmailField }) => {
    const classes = classnames(componentClass, 'nuAntForm');
    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const appDispatch = useAppDispatch();
    const {
        authState: {
            isProcessingLogin,
            isAuthenticated,
            authError
        } = {}
    } = useAppState();

    const initialCredentials = {
        email: emailValue || '',
        password: ''
    };

    const onCancelClick = () => {
        if (showPasswordReset) {
            setShowPasswordReset(false)
        } else {
            onCancel && onCancel();
        }
    };

    const onLoginSubmit = ({email, password}) => {
        const emailToUse = hideEmailField ? emailValue : email;
        appDispatch(logIntoApplication({email: emailToUse, password, onSuccess: onLoginComplete}));
    };

    const loginFormMessage = <div className={`${componentClass}__message`}>
        <h2>Log In</h2>
        <p>Enter your credentials below to get into the club!</p>
    </div>;

    const loginForm = <Form layout="vertical" initialValues={initialCredentials} onFinish={onLoginSubmit}>
        { !hideEmailField &&
            <Form.Item size={"large"} name="email" rules={[{ required: true, message: 'Enter your email', type: "email" }]}>
                <Input prefix={<MailOutlined className="text-primary"/>} placeholder="user@nutastic.net"/>
            </Form.Item>
        }
        <Form.Item size={"large"} name="password" rules={[{ required: true, message: 'Enter your password' }]}>
            <Input.Password prefix={<LockOutlined className="text-primary"/>} placeholder="Enter Password"/>
        </Form.Item>
        <Form.Item className="mt-5">
            <button type={"submit"} className="btn btn-primary" disabled={isAuthenticated || isProcessingLogin}>Login</button>
        </Form.Item>
    </Form>;

    const onForgotPasswordSubmit = ({ email }) => {
        appDispatch(forgotPasswordRequest({ email }));
    };

    const forgotPasswordMessage = <div className={`${componentClass}__message`}>
        <h2>Reset Your Password</h2>
        <p>Enter your email below to reset your password</p>
    </div>;

    const forgotPasswordForm = <Form layout="vertical" initialValues={initialCredentials} onFinish={onForgotPasswordSubmit}>
        <Form.Item size={"large"} name="email" rules={[{ required: true, message: 'Please input your email', type: "email" }]}>
            <Input prefix={<MailOutlined className="text-primary"/>} placeholder="user@nutastic.net"/>
        </Form.Item>
        <Form.Item className="mt-5">
            <button type={"submit"} className="btn btn-primary" disabled={isAuthenticated || isProcessingLogin}>Reset Password</button>
        </Form.Item>
    </Form>

    return <div className={classes}>
        { showPasswordReset ? forgotPasswordMessage : loginFormMessage }
        <div className={`${componentClass}__form`}>
            { showPasswordReset ? forgotPasswordForm : loginForm }
        </div>
        {
            (onCancel || showPasswordReset) && <div className="nuButtonGroup">
                <button className="btn btn-block btn-outlined btn-outline-black" onClick={onCancelClick}>{ showPasswordReset ? 'Back' : 'Cancel' }</button>
            </div>
        }
        { !showPasswordReset && <div className={`${componentClass}__textButton`} onClick={() => setShowPasswordReset(true)}>You forget the password again?</div> }
        { authError && <div className={`${componentClass}__error`}>{authError}</div> }
    </div>;
};

export default LoginForm;
